"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M19.621 1.363a3.382 3.382 0 0 1 3.374 3.194l.005.185v10.162a3.382 3.382 0 0 1-3.194 3.373l-.185.005h-8.235l-5.254 4.25a.476.476 0 0 1-.768-.28l-.009-.09v-3.88H4.38a3.383 3.383 0 0 1-3.375-3.193L1 14.903V4.743a3.383 3.383 0 0 1 3.195-3.375l.185-.005h15.24Zm0 .953H4.378c-.647 0-1.256.252-1.714.711A2.405 2.405 0 0 0 1.96 4.55l-.008.193v10.162a2.43 2.43 0 0 0 2.267 2.42l.16.006h1.452c.233 0 .427.168.468.39l.008.087v3.357l4.608-3.728a.48.48 0 0 1 .22-.098l.08-.007h8.404a2.43 2.43 0 0 0 2.421-2.267l.006-.16V4.745A2.43 2.43 0 0 0 19.78 2.32l-.16-.005ZM8.206 5.718h6.33l.08.015a.485.485 0 0 1 .26.123.49.49 0 0 1 .131.245l.01.093v.955l2.174-1.358a.476.476 0 0 1 .721.318l.008.085v6.533a.48.48 0 0 1-.246.417.502.502 0 0 1-.405.026l-.079-.04-2.173-1.358v.961a.48.48 0 0 1-.393.462l-.085.007H8.207c-1.22 0-1.379-2.7-1.398-3.535V9.26c.019-.827.174-3.541 1.398-3.541Zm5.857.953H8.25c-.124.151-.49 1.07-.49 2.789 0 1.686.348 2.57.496 2.77l.021.025 5.79-.006-.002-1.336a.476.476 0 0 1 .652-.444l.077.038 2.174 1.359V7.053l-2.174 1.359a.475.475 0 0 1-.72-.318l-.009-.085V6.67Z",
    clipRule: "evenodd"
  })]
});